import _ from 'lodash';
import { StoreType } from '../../../../enuns/store.enun';
import { translate, translateText } from '../../../../scripts/core/tools/translate';
import environment from '../../../../scripts/environment';
import api from '../../../../scripts/api';
import { FeaturePermission } from '../../../../constants/feature.permission.helper';
const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

export class DncFilterFactory {
    constructor({ options, currentMap }) {
        this.options = options;
        this.currentMap = currentMap;
    }

    getData() {
        const data = [];
        let salesTypeDataSource = environment.get('CONFIG.FILTERS.SALES_TYPE');
        let companySizes = environment.get('CONFIG.FILTERS.COMPANY_SIZES');
        const isDncConsolidate = environment.get('CONFIG.FILTERS.IS_DNC_CONSOLIDATE');
        companySizes = isDncConsolidate ? environment.get('CONFIG.FILTERS.COMPANY_SIZES_DNC_CONSOLIDATE') : companySizes;

        if ((this.options.id.indexOf('filter-dnc') !== -1) || (this.options.id.indexOf('filter-dnc-flexible-0') !== -1)) {
            salesTypeDataSource = _.filter(salesTypeDataSource, x => x.value < 3);
        }

        if (isAuthorized(FeaturePermission.LAYER_DNC.filterSegment)) {
            data.push({
                name: 'segments',
                data: _.reduce(environment.get('CONFIG.FILTERS.COMPETING_SEGMENTS'), (acc, val, key) => {
                    _.forEach(val, (v) => {
                        acc.push({
                            CD_CAT: key,
                            NM_CAT: key === 'competing' ? 'Competing' : 'Non Competing',
                            CD_SEGMENT: v.id,
                            NM_SEGMENT: translateText(v.nome, true)
                        });
                    });

                    return acc;
                }, []),
                position: 1,
                fields: [{
                    title: `${translate('Common.Classification')} ${translate('Common.Segment')}`,
                    name: 'competingClassification',
                    value: 'CD_CAT',
                    text: 'NM_CAT',
                    skipAll: true,
                    type: 'multiselect'
                }, {
                    title: translate('Common.Segments'),
                    name: 'models',
                    value: 'CD_SEGMENT',
                    text: 'NM_SEGMENT',
                    group: 'NM_CAT',
                    type: 'multiselect',
                    skipAll: true
                }]
            });
        }

        if (!isDncConsolidate) {
            if (isAuthorized(FeaturePermission.SYSTEM.showDataDirect)) {
                data.push({
                    name: 'channels',
                    position: 2,
                    fields: [
                        {
                            title: translate('Common.Channels'),
                            name: 'channels',
                            dataSource: _.map(environment.get('CONFIG.FILTERS.SALES_CHANNEL'), item => {
                                if (item.value === 0 && item.text === 'SELECIONAR TODOS') {
                                    item.value = -9999;
                                }
                                return item;
                            }),
                            value: 'value',
                            text: 'text',
                            type: 'multiselect',
                            skipAll: true
                        }
                    ]
                });
            }

            data.push({
                name: 'salesType',
                position: 4,
                fields: [
                    {
                        title: translate('Common.SalesType'),
                        name: 'salesType',
                        dataSource: salesTypeDataSource,
                        value: 'value',
                        text: 'text',
                        type: 'multiselect',
                        skipAll: true
                    }
                ]
            });
        }

        data.push({
            name: 'companySizes',
            position: 3,
            fields: [
                {
                    title: translate('Common.Port'),
                    name: 'companySizes',
                    dataSource: companySizes,
                    value: 'id',
                    text: isDncConsolidate ? 'nome' : 'text',
                    type: 'multiselect',
                    skipAll: true
                }
            ]
        });

        return data;
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/dnc.factory.js